'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Marketplace', href: '/marketplace' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Security', href: '#security' },
];

export default function HomepageNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-border shadow-sm'
          : 'bg-white/80 backdrop-blur-sm border-b border-border/50'
      }`}
    >
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link href="/" className="flex items-center">
          <Image
            src="/assets/images/EFF368A5-5FCF-40DA-8BB5-76EDC09B75CA-1779310043613.png"
            alt="Vaultis logo"
            width={120}
            height={36}
            className="h-9 w-auto object-contain"
            priority
          />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) => (
            <a
              key={`nav-${link?.label?.toLowerCase()?.replace(/\s/g, '-')}`}
              href={link?.href}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors duration-150"
            >
              {link?.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="text-sm font-medium text-foreground hover:text-primary transition-colors duration-150 px-4 py-2"
          >
            Login
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="text-sm font-semibold bg-primary text-white px-5 py-2 rounded-md hover:bg-primary/90 active:scale-95 transition-all duration-150"
          >
            Sign Up
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-b border-border px-6 pb-6 pt-2 animate-fade-in">
          <div className="flex flex-col gap-4">
            {navLinks?.map((link) => (
              <a
                key={`mobile-nav-${link?.label?.toLowerCase()?.replace(/\s/g, '-')}`}
                href={link?.href}
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {link?.label}
              </a>
            ))}
            <div className="flex flex-col gap-2 pt-2 border-t border-border">
              <Link
                href="/sign-up-login-screen"
                className="text-sm font-medium text-center text-foreground hover:text-primary transition-colors py-2"
                onClick={() => setMobileOpen(false)}
              >
                Login
              </Link>
              <Link
                href="/sign-up-login-screen"
                className="text-sm font-semibold text-center bg-primary text-white px-4 py-2.5 rounded-md hover:bg-primary/90 transition-all"
                onClick={() => setMobileOpen(false)}
              >
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}